import moment from 'moment-timezone';

export class EmailCriteriaMaintenanceData {
	public emailId: string;
	public emailFrom: string;
	public emailSubject: string;
	public emailDateSent: Date;
	public emailAddDate: Date;
	public emailAttachments: {
		rateMatrixLoaderName: string;
		emailAttachmentId: number;
		isProcessed: boolean;
		attachmentId: string;
		attachmentName: string;
	}[];

	constructor(emailCriteriaMaintenanceData?: EmailCriteriaMaintenanceData) {
		Object.assign(this, emailCriteriaMaintenanceData);

		this.emailDateSent = this.emailDateSent ? new Date(moment(this.emailDateSent).format('MMM DD, YYYY hh:mm:ss a')) : this.emailDateSent;
		this.emailAddDate = this.emailAddDate ? new Date(moment(this.emailAddDate).format('MMM DD, YYYY hh:mm:ss a')) : this.emailAddDate;
	}
}
